// extracted by mini-css-extract-plugin
export default {"Title":"iStyles_Title__WRbBt","SubTitle":"iStyles_SubTitle__IWU8I"};